<template>
  <div>
    <div class="card head-card news" v-if="showComponent">
      <div class="title-card">
        <h4>Offline</h4>
      </div>
      <div class="card-content">
        <div class="checkbox" v-if="mis_medios.indexOf('T')>=0">
          <label for="tv">
            <span class="btn-icon">
                <svg
                  fill="#02B99E"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  width="20px"
                  height="20px" 
                  viewBox="0 0 24 24"
              >
                <path
                  d="M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z"
                />
              </svg>        
            </span>
            <input
              class="box"
              type="checkbox"
              id="tv"
              value
              :checked="tv"
              @click="selectTV($event)"
            />
            Programas de televisión
            <span class="nbox">
              <svg viewBox="0 0 14.018 13.003">
                <path
                  id="Rectángulo_9"
                  data-name="Rectángulo 9"
                  d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                  transform="translate(-304.98 -380.994)"
                  fill="#fff"
                />
              </svg>
            </span>
          </label>
        </div>
        <div class="checkbox" v-if="mis_medios.indexOf('R')>=0">
          <label for="radio">
            <span class="btn-icon">
                <svg fill="#02B99E" xmlns="http://www.w3.org/2000/svg" height="20px" width="20px"  viewBox="0 0 24 24" ><path d="M0 0h24v24H0z" fill="none"/><path d="M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z"/></svg>
            </span>
            <input
              class="box"
              type="checkbox"
              id="radio"
              value
              :checked="radio"
              @click="selectRadio($event)"
            />
            Programas de radio
            <span class="nbox">
              <svg viewBox="0 0 14.018 13.003">
                <path
                  id="Rectángulo_9"
                  data-name="Rectángulo 9"
                  d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                  transform="translate(-304.98 -380.994)"
                  fill="#fff"
                />
              </svg>
            </span>
          </label>
        </div>
        <!--<div class="checkbox" v-if="mis_medios.indexOf('PD')>=0">
          <label for="news">
            <input
              class="box"
              type="checkbox"
              id="news"
              value
              :checked="noticieros"
              @click="selectNoticieros($event)"
            />
            Portales de noticias
            <span class="nbox">
              <svg viewBox="0 0 14.018 13.003">
                <path
                  id="Rectángulo_9"
                  data-name="Rectángulo 9"
                  d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                  transform="translate(-304.98 -380.994)"
                  fill="#fff"
                />
              </svg>
            </span>
          </label>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

import axios from "axios";
import { mapActions } from "vuex";
export default {
  name: "tvCatalog",
  components: {},
  data: () => ({
    tvComponent: "",
    showComponent: true,
    mis_medios:[]
  }),
  computed: {
    token(){
      return this.$store.getters.getToken;
    },
    url(){
      return this.$store.getters.getMainUrl;
    },
    tv() {
      return this.$store.state.projectConfig.fi.tv;
    },
    radio() {
      return this.$store.state.projectConfig.fi.radio;
    },
    noticieros() {
      return this.$store.state.projectConfig.fi.noticieros;
    }
  },

  methods: {
    selectTV(element) {
      if(element.target.checked == true){
        this.$store.commit('addfiParams',{mt:'T',arr:[1,1]});
      }
      this.$store.dispatch("selectTV");
    },
    selectRadio(element) {
      if(element.target.checked == true){
        this.$store.commit('addfiParams',{mt:'R',arr:[1,1]});
      }
      this.$store.dispatch("selectRadio");
    },
    selectNoticieros(element) {
      if(element.target.checked == true){
        this.$store.commit('addfiParams',{mt:'PD',arr:[1,1]});
      }
      this.$store.dispatch("selectNoticieros");
    },
    async getPermisosFeeds(){
      var self = this;
      return new Promise(resolve=>{
        axios.post(this.url+'getPermisosFeeds', JSON.stringify({token:self.token})) //petición
        .then((response)=>{
          self.isLoading = false;
          resolve(response.data);
        })
        .catch(function (error) {
          self.isLoading = false;
          var response = {success:false,error:error}
          console.log(error);
          resolve(response);
        });
      });
    }
  },
  async beforeMount() {
    var r = await this.getPermisosFeeds();
    console.log('erssssror');
    if(r.success){
      this.mis_medios = r.data.length>0? r.data : ['T','R'];
    }else{
      console.log('error');
      console.log(r);
    }    
  },
};
</script>

<style lang="scss">
</style>
